export default{
  // 公共的
  pub:{
    notLoad: "LoadError",
    sysYc: "System Exception",
    keyword: "Keyword",
    del: "Delete",
    delSc: "Deleted",
    cancel: "Cancel",
    sure: "Confirm",
    copy: "Copy",
    copyOk: "Copy Complete",
    browserNotCopy: "Automatic copying is not supported in this browser",
    save: "save",
    saveOk: "saved",
    operation: "Operation",
    preview: "Preview",
    edit: "Edit",
    delSure: "Delete Confirmation",
    ss: "Second",
    mm: "Minute",
    hour: "Hour",
    beginTime: "Start Time",
    endTime: "End Time",

    uploadFail: "Upload failed",
    uploadFailYy: "Reasons for upload failure",
    more: "More",
    submit: "Submit",
    operationSc: "Operation successful",
    close: "Close",
    xuhao: "No.",
    leixing: "Type",
    issureOperation: "Are you sure you want to do this",
    queren: "Confirm",
    error: "error",
    chooseAll: "Select All"
  },
  // 外框架 app.vue
  index:{
    homepage: "Home page",
    usercenter: "User Center",
    guideControl: "Direct Control",
    exit: "Exit",
    cloudLive: "Cloud Live",
    cloudDemand: "Cloud VOD",
    cloudProd: "Cloud Production",
    videoMs: "Video Microwebsite",
    livematches: "Live of events",
    gkSearch: "Generalization Search",
  },
  // 主页
  home:{
    overview:{
      videoTotal: "Total Video",
      nums: "",
      liveBroadcast: "Live Broadcast",
      currentAccount: "Account Balance",
      useParentTenant: "Use parent tenant package",
      storage: "Storage",
      notOpencc: "The storage function not enabled",
      lineTime: "Connection Duration",
      notOpenLine: "Line function not enabled",
      latelyUploadVideo: "Latest Uploaded Video",
      nowDay: "Today",
      sevenDay: "Last Week",
      mores: "More",
      notLoad: "LoadError",
      preview: "Preview",
      address: "Address",
      videoName: "Video Name",
      uploadTime: "Upload Time",
      noVideoContent: "No Video Content",
      liveChannel: "Live Channel",
      totalChannel: "Number of Channels",
      living: "Live",
      channelName: "Channel Name",
      createTime: "CreateTime",
      notLiveChannel: "No Live Channel",
      cloudYy: "Cloud Application",
      useGuide: "Enable Cloud Director",
      platform: "",
      newLineRoom: "Live Connection Room",
      onlinePs: "Online Connected Users",
      openDp: "Open the Databoard",
      openYysjdp: "Open the Video Operation Databoard",
      browserNotUse: "Your Browser Does Not Support。",
      mm: "Minute",
      yy: "Year",
      site: "Sessions",
      yh: "Original Resolution",
      sysYc: "System Exception",
      videoAddress: "Video Address",
      copy: "Copy",
      downLoad: "Download",
      cancel: "Cancel",
      sure: "Confirm",
      copyOk: "Copy Complete",
      browserNotCopy: "Automatic copying is not supported in this browser",
      channelAddress: "Channel Address",
      pushAddress: "Upstream Address",
      bfAddress: "Play Address",
      sourceCode: "Source Code",
      // Databoard
      overviewPreview:"OverviewPreview",
      thisMouthLive: "Live Activities this month",
      ended: "Finished",
      activityName: "ActivityName",
      cloudCutVideo: "Cloud Production video",
      // bigScreen2
      dataAnalysis: "Video Data Analysis",
      lookDate: "Calendar",
      month: "Month",
      monthLive: "Monthly live frequency",
      videoPlayNum: "Video views",
      live: "LIVE",
      onDemand: "VOD",
      liveviewingTrend: "Live Viewing Trends",
      viewNum: "monthly viewers",
      yxViewNum: "Monthly Active Viewers",
      videoTimeFb: "Video Duration Distribution",
      areaViewFb: "Viewer area distribution",
      province: "province",
      video: "   video",
      niandu: "yearly",
      thisMonth: "This Month",
      yesterday: "Yesterday",
      day: "day",
      noData: " no Data",
      liveNum: "Live Number",
      liveTimes: "Live duration",
      videoPlayNum: "Video Plays",
      videoNum: "Number of videos",
      zhejiang: "Zhejiang",
       qinghai: "Qinghai",
       jiangsu: "Jiangsu",
       xiagjiang: "Xinjiang",
       hainan: "Hainan",
       taiwan: "Taiwan",
       hebei: "Hebei",
       heilongjiang: "Heilongjiang",
       ningxia: "Ningxia",
       chongqing: "Chongqing",
       fujian: "Fujian",
       hunan: "Hunan",
       watchPs: "Number of Viewers",
    },
  },
  // 通道管理
  live:{
    liveLine: "Live Connection",
    channel:{
      channelManage: "Channel Management",
      keyword: "Keyword",
      newChannel: "New Channel",
      channelName: "Channel Name",
      createTime: "Create Time",
      status: "Status",
      channelType: "Channel Type",
      openClose: "ON/OFF",
      edit: "Operations",
      manage: "Manage",
      address: "Address",
      preview: "Preview",
      topush: "Stream Forwarding",
      monitor: "Monitor",
      del: "Delete",
      addRecordTask: "Add Recording Task",
      notLoad: "LoadError",
      notChannel: "No channel there, Create a new one now",
      nopoint: "No Input",
      pushAddress: "Upstream Address",
      bfAddress: "Playback Address",
      copy: "Copy",
      sourceCode: "Original bit rate",
      cancel: "Cancel",
      sure: "Confirm",
      cloudHomePage: "Cloud Live Homepage",
      pushFlow: "upstream",
      pullFlow: "downstream",
      notknow: "Unknown",
      noLiveStream: "No Live Stream",
      living: "Living",
      closed: "Closed",
      pulling: "Downstreaming",
      pullFailed: "Downstream Failed",
      waitPull: "waiting for pulling stream",
      pouse: "Pause",
      openChannel: "Channel  Opened",
      closeChannel: "Channel Closed",
      sysYc: "System Exception",
      cancelEdit: "Operation Cancelled",
      isSureOpenChannel: "Sure to open the channel?",
      isSureCloseChannel: "Sure to close the channel?",
      editSure: "Operation Confirmation",
      copyOk: "Copy Complete",
      browserNotCopy: "Automatic copying is not supported in this browser",
      delChannel: "Channel Deleted",
      delSure: "Deleted",
      isSureDelChannel: "Do you want to delete the channel?",
      resetSc: "Retry Succeeded",
      yh: "Original resolution",
      // addRecordTaskModal
      saveTask: "Save the Recording Task",
      recordChannel: "Recording Channel",
      chooseChannel: "Select Channel",
      taskName: "Task Name",
      maxWordst: "Include a maximum of 30 characters",
      recordTime: "Recording Time",
      beginTime: "Start Time",
      arrive: "to",
      endTime: "End Time",
      saveOk: "Saved",
      channelNotNull: "The Recording Channel Cannot Be Empty",
      channelNameNotNull: "The Recording Name Cannot Be Empty",
      chnnMaxword: "Maximum of 30 characters",
      timeMush: "Recording Begintime or Endtime Cannot Be Empty",
      endtimeDyBegintime: "The Recording Endtime Must Be later than the Begintime",
      ftTime: "Begintime Must Not Be Earlier than 48 Hours from Current",
      sixTime: "Begintime and Endtime Interval Should Not Exceed 6 Hours",
      xhhj: "Signal convergence",
      xhdd: "Signal scheduling",
      xhjk: "Signal monitoring",
      //distribution
      ffptMng: "Distribution Platform",  //Management
      ffPlatform: "Distribution Platform",
      ffAddress: "Distribution address",
      newPlatfrom: "New a distribution platform",
      ffIng: "Distribution in progress",
      ldle: "Idle",
      newPt: "New a platform",
      editPt: "Edit the platform",
      isSureDelPt: "Are you sure you want to delete the distribution platform",
      plsIptName: "Please enter the distribution platform",
      plaIptAds: "Please enter the distribution address",
      namePtNotNull: "Distribution platform and distribution address cannot be empty",
      // channelbuilt
      chooseLiveType: "Choose a Live Broadcast Way",
      basicInfo: "Basic Information",
      isClip: "Does It Support Realtime Editing?",
      isAnalysis: "Do You Want to Enable the Smart Analytics?",
      isSnapshot: "Do you want to enable the real-time screenshots?",
      isPorn: "Do you want to enable smart recognition?",
      pullInfo: "Pull Stream configuration information",
      advancesSetup: "Advanced Configuration",
      hlsDelayTime: "Stream Delay",
      ss: "Second",
      logoId: "Watermark",
      chooseLogo: "Select Watermark",
      newLoge: "Create a Watermark",
      xgLiveAdress: "Modifying the live broadcast watermark will refresh the streaming address. After modification, please use the new address for streaming ",
      nowZm: "Realtime Transcoding",
      name: "Name",
      mlkbps: "Bit Rate (kbps)",
      resolePower: "Resolution",
      mljfOne: "This Code rate is included in the billing for live transcoding, and 100M will be deducted for 1 minute of transcoding",
      mljfTwo: "This Code rate is included in the billing for live transcoding, and 200M will be deducted for 1 minute of transcoding",
      selfAdaption: "Adaption",
      mljfK: "This Code rate is included in the billing for live transcoding, and 1000M will be deducted for 1 minute of transcoding",
      outputProtocolsArr: "Broadcast Protocol",
      save: "Save",
      minOneMl: "Choose at least one Code Rate",
      halfHour: "Half an Hour",
      oneHour: "One Hour",
      tyHour: "24 Hours",
      selfSet: "Custom",
      pointChannelName: "Enter Channel Name",
      twoToTy: "2 to 26 Characters",
      minOneXy: "Choose at least one protocol",
      editChannel: "Edit Channel",
      saveChannelOk: "Channel Saved",
      issaveOk:"Saved",
      isSaveChannel: "Do you want to save the channel?",
      pealseChooseLoge: "Please choose the watermark to preview",
      // addWatermarkModal: creat  a New Watermark
      logoSet: "Watermark Settings",
      logoName: "Watermark Name",
      pointName: "Input Name",
      logoImg: "Watermark Image",
      logoShouldType: "Notes：For the best visual, the watermark should be a image in png or jpg format with out background",
      imgMaxOne: "Image size cannot be larger than 1MB",
      showPosition: "Display Location",
      axis: "Axis",
      logoSize: "Watermark Size",
      width: "Width",
      height: "Height",
      logoNameNotNull: "Watermark name cannot be empty",
      addLogeImg: "Please add watermark image",
      logeNameLong: "Watermark name is too long",
      // materialListModal2 Choose Image
      chooseImg: "Choose Image",
      chooseBdImg: "Choose Local Image",
      imgMaxOne: "Image size cannot exceed 1M",
      plsChooseImg: "Please Choose Image",
      imgTypeErr: "The format of the uploaded image is incorrect, please re-upload",
      uploadImgMaxOne: "Uploaded images cannot exceed 1M in size",
      uploadSc: "Uploaded Successfully",
      uploadFil: "Failed to Upload Image",
      // previewWatermarkModal
      logoPreview: "Watermark Preview",
      // PullVodPushLive
      livePullAddress: "Pull Streaming address for live",
      chooseVideoFile: "Choose Video File",
      pullAddress: "Downstream Address",
      pullAddressTYpe: "Pull Streaming support rtmp、hls、flv、rstp protocol",
      dbFile: "VOD file",
      chooseDbFile: " Please choose a VOD file",
      chooseDb: "Select On Demand",
      playType: "Playing Mode",
      sxPlay: "Play In Order",
      liXh: "List Play",
      mustLargeNow: "Must be later than current time",
      mustLargeBegin: "Must be later than begintime",
      sureHasZbl: "Please ensure that there is a stable live stream within this time period",
      pointPullAddress: "Please enter the streaming address",
      pullAdErr: "Streaming address protocol wrong",
      chooseTime: "Please select hour and minute",
      endTimeBigBeginTime: "Endtime must be later than start time",
      timeJg: "Endtime and Begintime interval must be less than",
      hour: "Hour",
      bgtSmallEdt: "Begintime must be latter than endtime",
      chooseBgt: "Please select a begintime",
      choosePlayType: "Please select a Play mode",
      chooseEdt: "Please select a endtime",
      chooseVideo: "Choose Video",
      dbLibrary: "VOD Library",
      fileMaxTen: "Supports maximum 10 VOD files",
      // channelrotate 转推
      pushToThird: "Forward to Third-party Platform",
      liveCode: "Live Code",
      broadcastLive: "To Live",
      stopLive: "Stop this Live",
      zdyPlatform: "Custom Platform",
      platformName: "Platform Name",
      platformNameNotNull: "Platform name cannot be empty",
      pushAdsMustRtmp: "Streaming address must be RTMP protocol",
      ptNmAndTladsNotNull: "Platform name or Streaming address cannot be empty",
      zbmAndTladsNotNull: "The live code or Streaming address cannot be empty",
      pushAddressNotNull: "Streaming address cannot be empty",
      notl_noFb: "The channel has no Stream, so the live cannot be published",
      pushLiveSc: "Publish Successfully",
      stopLiveSc: "Live  stopped",
      delSc: "Deleted",
      isDelPt: " Do you want to delete this platform?",
      // ChannelMonitor Monitor
      pushWatch: "Upstream Monitor",
      pushData: "Upstream Data",
      liveData: "Live Data",
      pushPullData: "Data Record",
      pushPullList: "Connection Record",
      tuiduanliu: "Disconnect the pushing stream",
      createTime1: "Creation time",
      duanliu: "disconnect stream",
      // LiveRecord History
      today: "Today",
      yesterday: "Yesterday",
      beforeYesterday: "Two days ago",
      begin_endTime: "Start Time ~ End Time",
      searchTimes: "The data of the last 60 days can be queried, and the query time period is less than 30 days",
      pushTimes: "Stream Duration",
      pushIp: "Upstream Client IP",
      pushFbl: "Upstream Resolution",
      stopReason: "Reason to Stop Upstream",
      maxTyDay: "The query period cannot exceed 30 days",
      // StreamData 推流数据
      searchSixDay: "The data of the last 6 days can be queried, and the query time period  is less than 6 hours",
      maxSixHour: "The query time period cannot exceed 6 hours",
      //ChartPart Video Frame Rate Video Code Rate Audio Frame Rate Audio Code Rate
      VideoFps: "Video Frame Rate",
      VideoRate: "Video Bit Rate",
      AudioFps: "Audio Frame Rate",
      AudioRate: "Video Bit Rate",
      nowNotPush: "No streaming in this time period",
      Company: "Unit",
    },
    // recordtasklist 录制任务
    recordtask:{
      recordtasklist: "Recording Task",
      keyword: "Keyword",
      lzrwTip: "Please create a new recording task within 48 hours after the completion of the live broadcast；single recording task cannot exceed 6 hours；The recorded video will be automatically deleted after 7 days, please move it to the VOD library in time",
      newRecordtask: "New Recording Task",
      taskName: "Task Name",
      recordTime: "Recording Time",
      createTime: "Creation Time",
      status: "Status",
      recordChannel: "Recording Channel",
      autoDel: "Auto Delete",
      operation: "Operation",
      finish: "Complete",
      notBegin: "Not Started",
      recording: " Recording",
      replayable: "Replayable",
      inSynthesis: "Compositing",
      recordFail: "Recording Failed",
      expiredDel: "Deleted due to expiration",
      dbkDel: "VOD library deleted",
      enterSck: "You has entered the material library",
      edit: "Edit",
      synthesis: "Compose Now",
      replay: "Playback",
      downLoad: "Download",
      moveToSck: "Move to Library",
      del: "Delete",
      notLoad: "LoadError",
      noRecordList: "There is no recording task , let's create a new one",
      browserNotUse: "Your browser does not support。",
      new: "New",
      Fail: "Fail",
      liveNoPush: "Live activity not pushing streaming",
      noOpenRecord: "Full recording of the channel not turned on",
      day: "Day",
      hour: "Hour",
      sysYc: "System Exception",
      delRecordListSc: "Delete recording task completed",
      recordingNotDel: "Task cannot be deleted while recording ",
      delSure: "Delete Confirmation",
      isSureDelRecordList: "Do you want to delete the recording task?",
      tuskSubmit: "Task Submitted",
      moveToSckSc: "Successfully moved to material library",
      tbFbSc: "Successfully synchronize to Editting Tool",
      noRecordFile: "Recording file does not exist",
      // addRecordTaskModal  Create/Modify Channel
      // playbackModal Replay
      replayAds: "Replay Address",
      copy: "Copy",
      lzwcEdit: 'Please click "Move to Material Library" in time after the recording task is completed, otherwise the playback address will be invalid after 7 days',
      noReplayAds: "Play address not generated",
      copyOk: "Copied",
      browserNotCopy: "This browser does not support automatic copying",
    },
    // watermarklist 直播水印
    watermark:{
      keyword: "Keyword",
      addLogo: "Add Watermark",
      notLoad: "LoadError",
      logoCode: "Watermark number",
      axis: "Axis",
      edit: "Edit",
      setDefaultLogo: "Set as default watermark",
      cancelLogo: "Cancel default watermark",
      noLogo: "The live watermark is empty",
      delLogoSc: "Watermark template deleted",
      sysYc: "System Exception",
      delSure: "Delete-Confirmation",
      isSureDelLogo: "Do you want to delete the watermark template?",
      operationSc: "Successful Operation",
      // addWatermarkModal 新建/编辑水印模板
      // materialListModal2 选择图片
    },
    //connectionList 直播连线
    connection:{
      lineDataList: "Connection Data",
      dsfll: "Third party pull flow",
      channelHas: "Channel already exists",
      issureDelchn: "Are you sure to delete this channel",
      empRoom: "The room is in idle state and cannot be switched on",
      nowtlTime: "Latest streaming time",
      rtmpAdd:"Please enter the streaming address. Only RTMP format is supported",
      addTooLang: "The pull stream address is too long",
      ordinaryRoom: "Regular Room",
      majorRoom: "Professional Room",
      newRoom: "New Room",
      roomName: "Room Name",
      type: "Type",
      createTime: "Creation Time",
      nowOnline: "Current Online Users",
      roomStatus: "Room Status",
      horizontal: "Horizontal screen ",
      vertical: "Vertical screen ",
      occupy: "Occupy",
      free: "Free",
      invitation: "Invite",
      enterRoom: "Enter",
      monitor: "Monitor",
      lineData: "Live Connection History",
      notCreateZbj: "Haven't created a live room yet～",
      functionNotOpen: "The function is not activated, please contact the administrator",
      delRoomSc: "Room Deleted Successfully",
      isSureDelRoom: "Do you want to delete this room?",
      serviceExceptions: "Service Exception",
      jieruLiveStream:'Live streaming',
      // builtRoomModal New Room
      rule1: "Please enter 1 to 10 Chinese characters, letters, numbers, spaces or underscores",
      rule2: "Chinese characters, letters, numbers, spaces or underscores",
      alias: "Alias",
      joinControl: "Join the Console",
      yes: "YES",
      no: "NO",
      createRoomJkyc: "The interface for create room is abnormal",
      sbRoomJkyc: "Report room interface abnormality",
      // enterRoomModal Enter the Room
      scyqmErr: "Error generating invitation code",
      aliasRepeat: "Alias occupied",
      roomLiving: "During the live of the room, setting to join the console failed",
      // recordListModal Line Record
      timeData: "Time Record",
      totalTime: "Total Duration",
      maxOnline: "Max Number of Online Users",
      cyData: "Member Record",
      cyName: "Member Name",
      recording: " Recording",
      searchErr: "Search Error",
      tjRecordListSc: "Successfully submitted the recording task",
      // inviteConfigModal Invitation Settings
      invitationSetting: "Invitation Settings",
      webInvitation: "WEB Invitation",
      copyInfo: "Copy Info",
      lineRoomName: "Room Name",
      roomCode: "Room Code",
      inviteCode: "Invitation Code",
      clickAddLine: "Click the link to join the room",
      appInvitation: "App Invitation",
      copyOpenApp: "Open the APP after copying this content",
      reCreateYqm: "Regenerate Invitation Code",
      appEwm: "APP QR Code",
      reSetTip: "Regenerating invitations will invalidate existing invitations",
      videoLine: "Video link",
      welcome: "Welcome",
      saveImg: "Save Image",
      openAndJoin: "Open the Daguan Live APP to join",
      useDaguan: "Use Daguan APP to scan the code",
      useWcAdd: "WeChat scan the code to join",
      clickJoin: "Click to Join",
      getRoomErr: "get Error Room Infor",
      // connectionMonitor Monitor
      roomMonitor: "Room Monitor",
      senderUid: "Sender",
      recieverUid: "Reciver",
      date: "Date",
      begin_endTime: "Start Time ~ End Time",
      search: "Search",
      wldbl: "Network Packet Loss Rate",
      wlyc: "Network Delay",
      yspml: "Video and Audio Bit Rate",
      videoZl: "Video Frame Rate",
      nodata: "No Data",
      sendDwl: "Sender Network (Packet Loss Probability)",
      sendDdb: "Sender Packet Loss",
      jsdwl: "Receiver Network (Packet Loss Probability)",
      jsddb: "Receiver Packet Loss",
      sendRTT: "Sender RTT",
      jsdRTT: "Receiver RTT",
      sendDml: "Sender Code Rate",
      totalSendMl: "Total Sending Code Rate",
      AudioRate: "Audio Code Rate",
      jsdml: "Receiver Code Rate",
      totalJsml: "Total Receiving Code Rate",
      sendDzl: "Sender Frame Rate",
      videoClZl: "Video Gather Frame Rate",
      videoSjZl: "Video Actual Frame Rate",
      jsdZl: "Receiver Frame Rate",
      export:'Export',

      yqLine: "Let's invite friends to join the room",
      dklj: "disconnect",
      zmShare: "Desktop Share",
      isSureLeaveRoom: "Are you sure to leave the room?",
      lineDk: "The connection is disconnected and cannot receive new messages, please check your network",
      joinPhone: "Joined the call",
      canotShare: "Your browser does not support this share type",
      dbVideo: "VOD",
      noColseOpt: "Do not close the browser or web page directly, if you want to stop the connection, please click the close room button",
      closeRoom: "Close the room",
      shexiangtou: "camera",
      stopShare: "Stop sharing",
      cancelShare: "Cancel Share",
      nowShare: "Share now",
      yaoqingLine: "Invite to join the line",
      videoSet: "Video and audio settings",
      inputClose: "AV input is closed",
      noJbShare: "No guest sharing",
      sharePm: "You are sharing your screen",
      closeRooming: "Closing the room, please wait...",
      gGhz: "1080P HD",
      gTjhz: "1080P recommended",
      mgGhz: "720P HD",
      mgTjhz: "720P recommended",
      msGhz: "540P HD",
      msTjhz: "540P recommended",
      sGhz: "360P HD",
      sTjhz: "360P recommended",
      sbsmFail: "Failed to report connection status",
      noKnowLine: "Unknown connection status",
      loginSc: "webim login successful",
      jsSendFail: "Failed to send dismiss message",
      mkf: "Microphone",
      cyMng: "Member Management",
      lining: "connecting",
      closeLine: "Disconnect",
      yaoqingPhone: "Invite to join the call",
      removeRoom: "Remove Room",
      waitJs: "Wait to accept",
      waitHj: "Waiting for a call",
      exitRoom: "Exit Room",
      lineRoomPlsing: "Waiting for a connection request...",
      yqphoneLine: "Invite you to make a video connection",
      jujue: "reject",
      jieshou: "Accept",
      beibojian: "Alternate Live Room",
      livingRoom: "Live Room",
      hmKzing: "Image is being controlled",
      sqsmFail: "Request to speak failed",
      zbCloseRoom: "The host closed the room",
      exitIMFail: "Failed to exit IM group",
      shangbaoFail: "Report failed",
      roomHao: "room number",
      roomUserName: "The nickname in the room, Chinese, letters or numbers",
      noLineRoom: "Not a line room",
      inRoom: "Already in the room, please try again later",
      enterRoomFail: "Failed to enter room",
      nameRe: "Name is occupied",
      caijiVideoFail: "Failed to capture video stream, please switch video device",
      fblNoZc: "The current resolution is not supported, the best resolution has been set for you! Highest supported",
      pmShareIng: "Sharing screen",
      dbShareIng: "Sharing VOD",
      vodJz: "muted",
      createIMFail: "Failed to create IM group",
      enterQunFail: "Failed to join the group",
      enterQunSc: "Join the group successfully",
      beginSharePm: "Start screen sharing",
      beginShareDb: "Start VOD sharing",
      endShare: "End Share",
      shareIng: "Sharing",
      shareSc: "Screen sharing successful",
      zxjqsq: "Execute the group application",
      sqjq: "Apply to join a group",
      sqJoinQun: "Apply to join your group",
      sqjqSc: "Execute the application to join the group is approved",
      sqjqErr: "The application to join the group was rejected.",
      sqjqBJJ: "The application to join the group was rejected",
      jjJoin: "Rejected your application to join the group, postscript",
      jsQun:"Execute the callback of disbanding the group",
      IMQunJS: "IM group disbanded",
      llqbzcDbShare: "The current browser does not support VOD sharing",
      vdoTypeErr: "Video format error",
      vdoShareSc: "Video shared successfully",
      sharePming: "screen sharing",
      roomNc: "The nickname is in the room",
      reEnter: "Enter the room repeatedly",
      roomIdErr: "Incorrect room number or invitation code",
      plsIptRoom: "Please enter the room number",
      plsIptRoomNc: "Please enter room nickname",
      zczhYc: "The account registration is abnormal",
      iptTip: "Please enter 1 to 30 Chinese characters, letters, numbers, spaces or underscores",
      waitYq: "Waiting for connection invitation",
      closeLlqBtn: "Do not close the browser directly, to stop the connection, please click the close/exit room button",
      clsRoom: "Closing the room, please wait",
      youRemoveRoom: "You have been removed from the room by the administrator",
      youDuankaiLine: "You have been disconnected by the administrator",
      noneMic:'No microphone detected',

      zcr: "Host",
      online: " people are currently connected",
      jingyin: "Mute",
      openSxt: "Turn on the camera",
      shareSreen: "Screen sharing",
    },
    srt:{
      SRTchannelManage: "SRT Channel Management",
      SrtChannel: "SRT Channel",
      baimingdan: "whitelist",
      liuID: "Stream ID",
      daoqiTime: "Expiration Time",
      editChannel: "Edit Channel",
      anquanModel: "Safe Mode",
      noJianquan: "No Authentication",
      tokenJianquan: "Token verification",
      ipBmd: "IP whitelist",
      tip1: "Note: In Token verification mode, the sending and receiving devices need to log in",
      tip2: "One IP per line, if you need to configure the network segment, you can replace it with *",
      cnNamenotNull: "Channel name cannot be null",
      editBmd: "Edit Whitelist",
      oneIp: "One IP per line;",
      channelList: "Channel record",
      sbSys: "Device System",
      ipAddress: "IP",
      netType: "Network Type",
      sbStatus: "Device Status",
      sbType: "Device Type",
      noLive: "No Live",
      srtLl: "SRT pull stream",
      searchTime: "The last 6 days can be queried, and the query time period is less than 3 hours.",
      searchTime2: "The query time period cannot exceed 3 hours",
      malv: "Bitrate",
      sendNum: "Number of packets sent",
      jieshouNum: "Number of received packets",
      diubaoNum: "Number of lost packets",
      resendNum: "Number of resends",
      thisTimeNoLl: "No pull streaming during this time",
      thisTimeNoTl: "No push streaming during this time",
      haomiao: "milliseconds",
      ge: "one",
      Company: "Unit",
    },
    srtLl:{
      srtLlManage: "SRT pull flow management",
      fwqIp: "Server IP",
      llIp: "Streaming IP",
      llStatus: "Pull flow state",
      nopull: "Undrawn flow",
      pullTime: "Pull flow time",
      lldIp: "Streaming end IP",
      area: "region",
      noList: "No record ～",
    },
    // flowmonitorList  直播流监控
    flowmonitor:{
      liveMatches: "Live Matches",
      liveMonitor: "Live Stream Monitoring",
      newMonitor: "New Monitor",
      bigScreenName: "Data Screen Name",
      bigScreen: "Data Screen",
      screenLayout: "Layout",
      createTime: "Creation Time",
      noLiveMonitor: "Live broadcast monitoring has not been created yet～",
      isSureDelMonitor: "Do you want to delete this monitoring",
      // flowmonitorEdit Live  broadcast flow monitoring modification
      layout: "Layout",
      bigScreenTopShow: "Show on Top",
      batchAdd: "Batch Add",
      openBigScreen: "Open the Data Screen",
      goOut: "Quit",
      noLive: "No live stream",
      noCut: "No Screenshots ",
      newCutTime: "Last Screenshot Time",
      notOpenSsjt: "Real-time screenshots are not turned on",
      addLive: "add a live stream",
      znjb: "AI Recognition",
      notOpen: "Not turned on",
      violation: "Violation",
      suspected: "Suspected",
      normal: "Normal",
      nameNotNull: "Name cannot be empty",
      // identifyRecordModal Recognition Records
      setUp: "Settings",
      tipBef: "If necessary, please download the image to local browsing or save, the system will",
      tipAft: "Automatically delete after 1 hour",
      download: "Download",
      noKown: "Unkown",
      yellow: "Sex Implication",
      terrorism: "Terrorism Content",
      politics: "Politics Content",
      // setMonitorModal Add Channel Monitor
      channelName: "Channel Name",
      status: "Status",
      monitorMode: "Monitor Mode",
      nowStream: "Real time stream",
      ssjt: "Real-time Screenshot",
      minOneChannel: "Choose at least one channel",
      addSc: "Added Successfully",
      autoPage: "Auto Scroll",
      jkChannelName: "Monitoring Channel Name",
      genghuang: "Replace",
      addChannel: "Add Channel",
      beginAdd: "to Add",
      dianji: "Click",
      bcyxz: "Selected this time",
      max100ge: "Select up to 100",
      // bigScreen 大屏
      shlJk: "Streaming data monitoring",
      llData: "pull stream data",
      malv: "Bitrate",
      zhenlv: "Frame rate",
      zhen: "frame",
      liuliang: "Data traffic",
      bingfs: "Concurrency",
      ci: "time",
      tianjia: "Add",
      delJkjl: "There is a deleted channel, the monitoring record has been auto cleared"
    },
    signal:{
      stopFf: "Stop distribution",
      xhy: "Signal source",
      chooseXh: "select signal",
      showCzhm: "Display frame extraction screen",
      moreInfo: "details",
      choosePt: "Select Platform",
      lddjz: "Stream signal source",
      sureStopFf: "Stop distribution confirmation",
      issureStopAll: "Do you want to stop all current distributions",
      changeSure: "Switch confirmation",
      isSureChange: "The current platform already has a signal source, do you want to switch",
      isSureDel: "The current live stream is being redirected. Deleting this channel will affect the redirected image. Do you want to continue",
      chooseFfPt: "Select distribution platform",
      plsChoosePt: "Please select a platform",
      xhyxq: "Signal source details",
      beginTlTime: "Start streaming time",
      dataMolitor: "monitoring data",
      xhyPx: "Signal source sorting",
      ffptPx: "Distribution platform sorting",
    }
  },
  channel:{
    chooseChannel: "Select a Channel",
    ptChannel: "Normal Channel",
    liveStatus: "Live Status",
    sszbtd: "Event live channel",
    quanbu: "All",
    zhunbeiing: "In preparation",
    canCt: "Removable bar",
    plsChooseTd: "Please select a channel",
  },
// vod cloud
  vod:{
    videoUpload: "Video Upload",
    videoManage: "Video Management",
    commentManage: "Compilation Management",
    plManage: "Comment Management",
    rideoMng: "Audio Management",
    // uploadList video upload
    uploadList:{
      uploadTo1: "Upload to",
      uploadTip: "The file is being uploaded, please do not refresh or close this page",
      enable: "Enable",
      deactivate: "Deactivate",
      zm_sy: "Transcode/Watermark",
      beginUpload: "Start uploading",
      addMoreVd: "Add More Videos",
      fileName: "File Name",
      size: "Size",
      status: "Status",
      type: "Classification",
      chooseVideoUpld: "Choose video file to upload",
      tzdckUpload: "Or directly drag and drop the file to this window",
      maxFt: "Maximum 40 characters",
      waitUpload: "Waiting for upload",
      uploading: "Uploading",
      uploaded: "Upload completed",
      chooseTemp: "Choose Template",
      chooseLogo: "Choose Watermark",
      tsUpload: "Upload at the same time",
      geFile: "files",
      videoTypeErr: "The video format is incorrect",
      videoNameMaxFt: "The video name cannot exceed 40 characters",
      file: "file",
      uploadSc: "Upload successful",
      videoNameNotNull: "The video name cannot be empty",
      plsCsVideo: "Please select a video",
      // transcodeWatermarkModal transcode/watermark
      zmTemp: "Transcoding Template",
      logoTemp: "Watermark Template",
      chsSyOrZmTemp: "Please select a watermark template or transcoding template",
      chooseWjj: "Choose Folder"
    },
    // videoManageList video management
    videoManageList:{
      begin_endTIme: "Start Time ~ End Time",
      byName: "By Name",
      byLabel: "By Label",
      bycharacter: "By character",
      plsPointKeyword: "Please enter a keyword to search",
      enable: "Enable",
      deactivate: "Disable",
      join: "Join",
      classify: "classify",
      collection: "Compilation",
      zm: "transcode",
      qrcs: "Embedding Parameters",
      cut: "Cut",
      info: "Basic Info",
      status: "Status",
      uploadTime: "Upload Time",
      enableStatus: "Enable Status",
      shStatus: "Audit Status",
      size: "Size",
      time: "Duration",
      processing_zm: "Processing (Original file transcoding is successful)",
      processing: "Processing",
      zmSc: "Transcoding succeeded",
      zmFail: "Transcoding failed",
      thirdPass: "Three trial passed",
      secondPass: "Second trial passed",
      firstPass: "First trial passed",
      notApproved: "Pending",
      thirdNotPass: "Failed to pass the third trial",
      secondNotPass: "Failed to pass the second trial",
      firstNotPass: "Failed to pass the first trial",
      address: "Address",
      yuny: "Operation",
      share: "Share",
      douyin: "Douyin",
      toutiao: "Toutiao",
      sourceChange: "Change video source",
      embed: "Embed",
      noVideoFIle: "There is no video file yet~",
      allVideo: "All Videos",
      uploadVideo: "Upload Video",
      recordVideo: "Record Video",
      cloudCut: "Cloud Cut",
      shortVideo: "Short Video",
      thirdParty: "Third Party",
      operationSc: "Operation successful",
      delVideoSc: "Delete video successfully",
      isSureDelVideo: "Sure to delete the video",
      plsChooseVideo: "Please select a video",
      setSc: "Set successfully",
      radioFile: "Audio File",
      notZm: "Cannot do transcoding",
      plzmtjSc: "Batch transcoding task submitted successfully",
      videoXz: "The selected Video duration or file size exceeds the rules, please refer to the video sharing specification",
      ckxq: "View Details",
      noCutGn: "Cut function not enabled",
      hasZmfailVideo: "Contains video with unsuccessful transcoding",
      // transcodeWatermarkModal 转码/水印
      // playUrlModal 播放地址modal
      // previewModal 视频预览
      playAddress: "Play address",
      browserNotUse: "Your browser does not support it.",
      yh: "Original Resolution",
      // changeSourceModal change source modal
      chooseBdFile: "Choose local file",
      uploadProgress: "Upload process",
      logo: "Watermark",
      chooseLogo: "Choose Watermark",
      logeTip: "The historical watermark has been deleted, please specify a new watermark",
      beginUpload: "Start uploading",
      pauseUpload: "Pause upload",
      cancelSure: "Cancel Confirmation",
      isSureCancel: "Are you sure you want to cancel the upload",
      uploadSc: "Upload successful",
      // toClassifyModal 加入到分类modal
      addToTYpe: "Add to Type",
      typeName: "Type Name",
      chsSyOrZmTemp: "Please select a watermark template or transcoding template",
      // toCompilationModal is added to the compilation modal
      addToCollection: "Add to Collection",
      addClctSc: "Add to Collection Successfully",
      chooseClct: "Please select a compilation",
      // vodEditModal on-demand editing modal
      name: "Name",
      plspointName: "Please enter a name",
      cover: "cover",
      uploadImg: "Upload Image",
      jianjie: "briefing",
      plsPointJj: "Please enter a briefing",
      videoNameNotNull: "The video name cannot be empty",
      oneToFt: "1 to 40 characters",
      uploadImgSc: "Upload image success",
      uploadImgFail: "Failed to upload image",
      imgTypeErr: "The format of the uploaded image is incorrect, please re-upload",
      modifiedSc: "Modified successfully",
      // implantModal 单个嵌入设置modal
      bfqSize: "Player size",
      autoPlay: "Autoplay",
      width: "width",
      height: "High",
      showAuto: "If one of the items is 0, it means that the item is adaptive",
      copyCode: "Copy Code",
      videoYsSize: "Video original size",
      selfSet: "custom",
      // implantAllModal all嵌入设置modal
      zcyhPlay: "Support Original Resolution play",
      // sharedNormsModal 抖音视频分享规范
      dyspfxgf: "Douyin Video Sharing Specification",
      ttspfxgf: "Toutiao Video Sharing Specification",
      dyfxTip1: "The video file should less than 300M, and within 1 minute。",
      dyfxTip2: "Videos with brand logos or brand watermarks will violate Douyin rules. It is strongly recommended that third-party applications handle non-compliant watermarks in shared content by themselves.",
       dyfxTip3: "After the video is shared to Douyin, Douyin will review it, and the video review logic is consistent with other methods.",
       ttfxTip2: "Videos with brand logos or brand watermarks will violate Douyin rules. It is strongly recommended that third-party applications handle non-compliant watermarks in shared content by themselves.",
       ttfxTip3: "After the video is shared to Toutiao, Toutiao will review it, and the video review logic is consistent with other methods.",
       IKonw: "I know",
      // douyinShareModal 抖音分享
      doeyinShare: "Douyin Share",
       shareTo: "Share to",
       shareData: "Share record",
       zhgq: "Account expired",
       videoMs: "Video description",
       addZhL: "Add Account",
       shareTime: "Share Time",
       zhName: "Account Name",
       shareStatus: "Share Status",
       close: "close",
       success: "Success",
       sharing: "Sharing",
       fail: "Failed",
       chooseZh: "Please select an account",
       subSc: "Submit success",
      // toutiaoShareModal 头条分享
      toutiaoShare: " Toutiao Share",
      // vodInterception2 智能识别截取
       yl_jq: "Preview/Intercept",
       jqTime: "Time Intercept",
       noHcpd: "No synthetic fragment",
       noEditQy: "Inoperable area",
       znLabel: "Smart Label",
       yysb: "Speech Recognition",
       faceSb: "Face Recognition",
       videoCut: "Video screenshot",
       downloadSRT: "Download SRT",
       reSb: "Re-Identify",
       noyysbCont: "No speech recognition content",
       noFaceSbCont: "No face recognition content yet",
       timeNotNull: "Time cannot be null",
       timeTypeErr: "Incorrect time format",
       timeNotYy: "Time is not within the valid range",
       begin: "begin",
       end: "end",
       endTimeLgBeginTime: "End time should be later than begin time",
       cutSc: "Cut Succeeded",
       fqsbSc: "Initiate recognition successful",
       notSb: "Not recognized",
       sbing: "Recognizing",
       sbFail: "Recognition failed",
       inSynthesis: "Composing",
       hechengFail: "Failed to compose",
       finished: "completed",
      // videoManageOperation  运营
     hdSet: "Interaction Settings",
      pageSet: "Page Setup",
      msgInteraction: "Message Interaction",
      kaiqi: "Open",
      lysh: "Message Review",
      xshf: "Review before publishing",
      xfhs: "Publish first and then review",
      viewSet: "Authorized Viewing Settings",
      noXz: "Unlimited",
      yzmView: "Invitation code to view",
      userCanViewPd: "Users can freely view this channel",
      textTip: "Tip text",
      plsIptTextTip: "Please enter the tip text",
      zdyYzm: "Custom verification code",
      plsIptYzm: "Please enter the invitation code",
      plsTxYzm: "Please fill in the invitation code",
      wxgzhQr: "Embedding WeChat Official Account",
      addAddressToWx: "Add the following address to your WeChat Official Account custom menu, viewers can quickly access your live page by clicking on the Official Account menu",
      qrwxgzhAds: "Embed the address of the WeChat public account",
      zdyPlay: "Custom Play Page",
      gzyd: "Induce to follow",
      ggl: "Ad Column",
      dbList: "VOD List",
      viewPsNum: "Number of viewers",
      openClose: "Switch",
      ewm: "QR code",
      dbText: "Bottom Text",
      gzhName: "WeChat Official account name",
      xgslt: "Example",
      plsUploadImg: "Please upload an image first",
      dbTextNotNull: "The bottom text cannot be empty",
      gzhNameNotNull: "WechatOfficial account name cannot be empty",
      uploadImgSize: "It is recommended to upload an image with a size of 1080*135 pixels",
      text: "Text",
      image: "image",
      plsIptText: "Please enter text",
      ddggtz: "Click the ad to go to",
      plsIptTzlj: "Please enter the transfer link",
      newGg: "New Ad",
      isSureDel: "Are you sure you want to delete",
      editGg: "Edit Ads",
      ggTextNotNull: "Ad text cannot be empty",
      ggImgNotNull: "Ad image cannot be empty",
      modeName: "module name",
      chooseHj: "Choose a video Compilation",
      modeNameNotNull: "The module name cannot be empty",
      hjNotNull: "Compilation cannot be empty",
      showType: "Display Type",
      totalNum: "Total number of people",
      videoplayNum: "Video playback volume",
      addType: "Optimized form",
      mrjcNum: "Basic Number",
      people: "people",
      sjNum: "Actual number of people",
      times: "times",
      notes: "Note",
      jsfs: "Display audience number = base number + actual number × multiple",
      addTip: "This data is only displayed for users, and the system data is counted with real data",
      plEdit: "Batch Operations",
      newFloal: "New Folder",
      returnLast: "Go Back",
      allFile: "All files",
      resetName: "Rename",
      fileboxNotNull: "Folder name cannot be empty",
      moveTo: "move to",
      uploadTo: "Upload to",
      filebox: "Folder",
      movetoThis: "Move to Here",
      uploadtoThis: "Upload here",
      nowNoVideo: "No video yet",
    },
    // 音频管理
    rideoManage:{
      uploadIng: "The file is currently being uploaded. Please do not refresh or leave this page",
      ypName: "Audio Name",
      ypType: "Audio type",
      uploadYp: "Upload audio",
      loadToUp: "Waiting for upload",
      uploadTo: "Upload to",
      uploadFail: "Upload failed",
      uploadEnd: "Upload completed",
      noYpfile: "I don't have any audio files yet",
      bdUpload: "Local Upload",
      zbLz: "Live Recording",
      isSureDelFile: "Are you sure you want to delete this audio file",
      typeFail: "Incorrect audio format",
      filenameTooLong: "Audio name cannot exceed 50 characters",
      ypLogo: "Audio Cover",
      mp3Address: "MP3 address",
      m4aAddress: "m4a address",
      play: "Play",
      noUseBq: "Your browser does not support audio tags",
    }
  },
  // production 云制作
   production:{
     guideMng: "Director Management",
     cgMng: "CG management",
     materialMng: "Material Management",
     pictureSplicing: "Picture Splicing",
    // directorList 导播管理
    directorList: {
      useNewChromeTip: "In order to ensure the normal operation of the director panel, it is recommended to use the latest version of the Chrome browser",
      newguide: "New Director Panel",
      guideId: "Director Panel ID",
      guideName: "Director Panel Name",
      guideStatus: "Director Panel Status",
      guideSyTime: 'Balance of Duration',
      open_close: "Enable/Disable",
      zeng: "Give for free",
      enterGuide: "Enter Director Panel",
      xiugai: "Modify",
      noGuideToBuide: "The director panel has not been created yet, go and create a new one~",
      welcomeUseGuide: "Welcome to the Rongyun Director panel",
      chooseGuideTime: "Choose the duration of the guide panel",
      chooseGuideType: "Choose Director's Panel Mode",
      normalMode: "Regular Mode",
      active_standby: "Master and Standby Mode",
      ljxhjr: "Connection Signal Input",
      guideTip1: "The cloud director panel can input the connection signal and return it through a low-latency signal, ",
      guideTip2: "to achieve the effect of program production such as dialogs between reporters and hosts, guest interviews, etc.",
      PGMhmfs: "PGM Screen Return",
      gudieTip3: "The PGM screen of the cloud director will be sent back to the connection room,",
      guideTip4: "and frontline reporters  can view the current broadcast situation in real time.",
      billingType: "Billing method",
      oneUseOne: "1 minute director panel consumes 1G live broadcast data balance",
      plsTime: "Please ensure sufficient time is available for the director panel",
      payAttenTion: "Attention",
      attion1: "The director panel is used first and then paid. If the director ends early, the fee will only be deducted according to the length of use,",
      attion2: "When the balance is insufficient, the director panel will give you 15 minutes, and then it will automatically close. Please make sure that the director panel has sufficient time remaining; the billing will start after creation.",
      chooseLineRoom: "Select Line Room",
      cloudProduct: "Cloud Post Production Homepage",
      oneHour: "One hour",
      twoHour: "Two hours",
      threeHour: "Three hours",
      fourHour: "Four hours",
      fiveHour: "Five hours",
      sixHour: "Six hours",
      sevenHour: "Seven hours",
      resourceDoing: "Resource in preparation",
      guideing: "Director in progress",
      resourceReturn: "Resource returning",
      guideStop: "Director Stop",
      noKown: "Unknown",
      roomUseing: "The director panel is in use, please try again later",
      serviceExceptions: "Service exceptions",
      guideDis: "Director panel disabled",
      isSureDisGuide: "Are you sure you want to disable this director panel",
      opSure: "Operation Confirmation",
      noRoomPlsChs: "The room no longer exists, please select again",
      guideNameNotNull: "Director panel name cannot be empty",
      roomMust: "A room must be selected for connection signal",
      plsChooseLineRoom: "Please select a connection room",
      delGuideSc: "Delete Director Panel Successfully",
      isSureDisRoom: "Are you sure you want to delete this director panel",
      // directorManagementActive 导播控制页面
      guide: "Director Panel",
      canuseTime: "Available Duration",
      addTime: "Add Time",
      goOut: "Exit",
      noLive: "No live stream",
      mode: "Template",
      compositePicture: "Composite Picture",
      change: "Switch",
      outPlay: "Output Settings",
      delayPic: "Delayed Video",
      soundMonitor: "Sound Monitor",
      volume: "Volume",
      mediaSource: "Media Source",
      taibiao: "TV station logo",
      img: "Image",
      caption: "Subtitle",
      keyboard: "Hotkey",
      keyboardSign: "Hotkey Description",
      sign1: "Ctrl+Number: output to PVW",
      sign2: "Number: output to PGM",
      sign3: "Enter: PVW/PGM switch",
      pointSet: "Input Settings",
      voiceWatch: "Voice Monitoring",
      voiceOutput: "Voice output directly",
      setPosition: "Adjust Position",
      toping: "Top",
      setUp: "Setup",
      detPic: "Default Picture",
      picFollow: "Follow the picture",
      addCap: "Add Caption",
      horseLamp: "Horse race lamp",
      chooseStateLogo: "Choose a logo",
      chooseImg: "Choose an image",
      position: "Position",
      leftTop: "Top Left",
      rightTop: "Top right",
      leftBottom: "Bottom Left",
      rightBottom: "Bottom right",
      chooseSry: "Select Input Source",
      liveChannel: "Live Channel",
      dbsc: "VOD material",
      chooseSrtd: "Select Input Channel",
      pushAddress: "Push address",
      allVideo: "All Videos",
      uploadVideo: "Upload Video",
      lzVideo: "Record video",
      cloudCutVideo: "Cloud Cut Video",
      editZm: "Edit subtitles",
      fontFamily: "Font",
      fontSize: "Font Size",
      fontColor: "Font Color",
      bgColor: "Background Color",
      qiehuan: "Switch",
      followHm: "Follow the screen",
      yes: "Yes",
      captionSpeed: "Text Speed",
      fast: "fast",
      nomal: "Medium",
      man: "slow",
      bgBtmd: "Background Color Opacity",
      captionContent: "Text content",
      chooseChannel: "Choose Channel",
      definitionSet: "Definition Setting",
      scml: "Output Bitrate",
      resolePower: "Resolution",
      playPt: "Broadcast Platform Setting",
      delayTl: "Upstream Latency",
      chooseSctd: "Select output channel",
      dbtxf: "Director Panel Renewal",
      chooseDbTime: "Choose Director Duration",
      jffsSm: "Director consumes 1G of live streaming data for 1 minute (or 50 minutes of viewing time)",
      jffsTs: "Please ensure that the cloud director has enough time or the live broadcast time is at least longer than the cloud director time",
      jffsTip1: "The cloud director panel adopts the form of first use and then payment. If the director ends early, the fee will only be deducted according to the length of use,",
      jffsTip2: "When the balance is insufficient, the cloud director panel will give you 15 minutes, and it will be automatically closed when it is out of date. Please make sure that the live broadcast time is sufficient; the billing will start after creation.",
      toolTip: "Tip",
      tipContent: "After closing, the cloud director panel will stop outputting, and the remaining cloud director time will not be billed. You need to reopen it if you use it again.",
      wryh: "Microsoft Yahei",
      songti: "Song Ti",
      heiti: "Heiti",
      kaiti: "Kaiti",
      closeSure: "Close Confirmation",
      plsClickToClose: "The cloud director panel has been disabled, please click to confirm to close the director",
      cannotEditUsing: "Cannot modify the camera in use",
      plsChooseChannel: "Please select an input channel",
      plsChooseFile: "Please select an on-demand file",
      notDelUse: "Unable to delete a camera in use",
      notDelRadioJw: "Cannot delete camera sound is outputting",
      isSureDelJw: "Are you sure you want to delete this camera",
      videoJy: "The sound cannot be output when the video is paused",
      hcSc: "Successful synthesis",
      qiehuanSc: "Successful switch",
      hcJwNull: "Synthetic camera does not exist or there is no live stream",
      cfjw: "There is a duplicate camera position and cannot be synthesized",
      plsChooseTemp: "Please select a composition template",
      canUseTimeTt: "The available time is less than 30 minutes, please add the cloud director time immediately",
      canUseTimeTen: "The available time is less than 10 minutes, please add the cloud director time immediately",
      balance: "Your balance is insufficient, the director panel will give you 15 minutes for free, please recharge in time",
      xfSc: "Renewal successful",
      dbtStop: "Director panel has stopped and cannot be recharged normally",
      balanceAndRecharge: "Insufficient balance, please recharge",
      plsStopToPzxx: "Please stop live streaming before setting configuration information",
      plsChooseOneChannel: "Please choose an output channel",
      setSc: "Set successfully",
      stopOutput: "Stop output",
      beginOutput: "Start output",
      isSureDelTabiao: "Are you sure you want to delete this logo",
      addSc: "Added successfully",
      isSureDelPic: "Are you sure you want to delete this picture",
      setTopSc: "Topped",
      contentNotNull: "Text content cannot be empty",
      isSureDelZimu: "Are you sure you want to delete this subtitle",
      netErr: "Network Error",
      videoDecodingErr: "Video decoding error",
      notPlayVideoType: "This video format is not supported to play",
      nousePlayerOnFile: "Do not use the player under the file protocol",
      parameterErr: "Incorrect use of parameter",
      pointVideoAddress: "Please fill in the video playback address",
      liveEnd: "Live has ended",
      getVideoFail: "Failed to get video",
      kybjj: "Cross-Origin Access Denied",
      // directorPreview 导播预览页面
      yulanDelay: "Preview: delay",
      yh: "Original Resolution",
      // directorStation 导播台操作
      qpEdit: "F11 key: full screen operation",
      fullScreen: "Full Screen",
      jjqb: "Emergency Cut",
      hfzb: "Resume live streaming",
      stopZb: "Stop live streaming",
      beginZb: "Start Live",  //broadcast
      mixer: "Mixer",
      yspStemp: "Audio and video synchronization",
      beforeImg: "Foreground Image",
      bgImg: "Background Image",
      guideSc: "Import Material",
      noImgSc: "No image material yet",
      guideZm: "Import Subtitle",
      box: "box",
      text: "Text",
      title: "Title",
      noZmsc: "No subtitle material",
      noLineRoom: "No Line Room",
      lineRoomJsL: "The line room has been dismissed",
      cyName: "Member Name",
      seat: "Camera",
      invitation: "Invitation",
      remove: "Remove",
      joinCall: "Join the call",
      endCall: "End Call",
      voice: "Voice",
      video: "Video",
      noDDRsc: "No DDR material now",
      waitDownload: "Download not started",
      downloading: "Downloading",
      downloaded: "Download complete",
      downloadFail: "Download failed",
      entryPoint: "entry",
      outPoint: "Out",
      cycleIndex: "Number of cycles",
      infinite: "Infinite",
      startLocation: "Start location",
      videoEntryPoint: "Video Entry Point",
      followPIP: "Follow the PIP screen",
      addDDRsc: "Add DDR material",
      system: "system",
      chooseInpSource: "Choose Input Source",
      pushFlow: "Upstream",
      pullFlow: "Downstream",
      pushType: "Stream Type",
      RTMPchannel: "RTMP channel",
      SRTpush: "SRT Upstream",
      sytlfs: "Applicable to SRT point-to-point upstream",
      fzzthtl: "Copy the SRT address and paste it into the upstreaming device for streaming",
      UDPPush: "UDP Upstream",
      syUDPtlfs: "Applicable to UDP point-to-point upstream",
      UDPfzzttl: "Copy the UDP address and paste it into the upstreaming device for streaming",
      channelAddress: "Channel Address",
      srtAddress: "SRT Address",
      udpAdress: "UDP Address",
      pullAddress: "Downstream Address",
      xyAddress: "The address of rtmp, srt, http or udp protocol",
      chooseVideoFile: "Select Video File",
      editBeforeImg: "Edit Foreground Image",
      name: "Name",
      inputName: "input name",
      transparency: "Transparency",
      picFollow: "Video Follow",
      editBgImg: "Edit Background Image",
      chooseMode: "Choose Template",
      editMode: "Edit Template",
      lcdmbk: "Save to Template Library",
      front: "front",
      dehind: "behind",
      add: "Add",
      chooseCaptionBox: "Choose the subtitle box",
      editName: "Edit",
      captionBoxName: "subtitle box name",
      plsInpName: "Please enter a name",
      showType: "Display Mode",
      showFixed: "Fixed display",
      cyclicScroll: "Cyclic Scroll",
      textSpeed: "Text Speed",
      textFamily: "Text font",
      textSize: "Text Size",
      textColor: "Text Color",
      BgTmd: "Background Transparency",
      content: "Content",
      setOutput: "Output Settings",
      outputTo: "Output to",
      zdyPush: "Custom Upstream",
      outputChannel: "Output Channel",
      rtmpOrsrtXydd: "rtmp or srt protocol address",
      jjbb: "Emergency Backup",
      openClose: "ON/OFF",
      canOpenJjbp: "Set a delay of more than 3 seconds to open the emergency backup video",
      chooseVideo: "Select Video",
      notStart: "Not Started",
      zhz: "Transcoding",
      zyzbwc: "Resource ready",
      zyzbFail: "Resource preparation failed",
      guideRenew: "Director Panel Renewal",
      chooseGuideTime: "Duration",
      exitTip: "Exit Tip",
      hmPreview: "Screen Preview",
      null: "none",
      guideNoCont: "This camera has no content and cannot be added",
      cannotAddmoreJw: "Cannot add more cameras",
      bdbNotEditWatch: "Backup director cannot modify monitoring",
      plsChooseRtmpChannel: "Please choose a rtmp channel",
      plschooseSrtChannel: "Please select a srt channel",
      plsChooseUdpChannel: "Please choose a udp channel",
      pullAddressNotNull: "The pull address cannot be empty",
      pullAdressType: "The pull address must be rtmp, srt, http or udp protocol",
      notChangeHm: "Cannot switch screen",
      qwpfcz: "Do not operate too frequently",
      pushAddressNotNull: "The push address cannot be empty",
      pushAddressMustType: "The push address must be rtmp or srt protocol",
      openJjbb: "Enable emergency broadcast, delay push streaming must be longer than 3 seconds",
      addAJjbbVideo: "Please add an emergency backup video",
      sourceZbz: "The backup resource is being prepared, the bit rate and resolution cannot be modified",
      plsSetSccs: "Please set output parameters",
      plsChooseAChannel: "Please select an output channel",

      // sxb4director.js
      notDelUseJw: "Unable to delete a camera in use",
       notEditUseJw: "Cannot modify the camera in use",
       lineRoomNoExistence: "Line room does not exist",
       LoginLineRoomErr: "Login line room error",
       roomJkYc: 'Report the room interface is abnormal',
       exitLiveFail: "Failed to call exit Live API",
      // im4director.js
       acceptedInvitation: "Invitation accepted",
       refuceJoin: "Refused to join the room",
       leaveRoom: "Leave the room",
       enterRoom: "entered the room",
       disconnected: "Disconnected",
       jsIMfail: "Failed to dissolve IM group",
       maxEtTh: "Support up to 8 people to link",
      // imClient4director.js
      loginIMFail: "Login to IM failed",
       errCode: "Error Code",
       createQzFail: "Failed to create group",
       editQbmFail: "Failed to modify group alias",
       joinIMQzFail: "Failed to join IM group",
       joinIMFailContent: "Failed to join IM group, response status information",
       joinQzFail: "Failed to join group",
       exitQzFail: "Failed to exit group",
       editTIMFail: "Failed to exit TIM",
       sendQzFail: "Failed to send group message",
       sendc2cFail: "Failed to send c2c message",
       joinIMQzSc: "Joined IM group successfully",
       c2cIMxx: "c2c unknown IM message",
       noKownIM: "Unknown IM message",
       sysQinfo: "System group message",
      // rtc4director.js
       plsSureWl: "Please make sure your network connection is normal, you can experience our Demo first to make sure the network connection is normal",
       plsSureInfo: "Also, please make sure your account information is correct.",
       plsOpenLink: "Please open the link",
       showMoreInfo: "Query detailed error information",
       rtcYc: "The rtc network is abnormal, please refresh the page and try again",
       shareScreen: "Screen Share",
       shareDb: "Share on Demand",
      // ddr4director.js
      chooseVideoAndMinTime: "Please select a video no less than 5s",
      cannotDeluse: "Cannot delete resources in use",
      isSureDelSource: "Are you sure you want to delete this resource",
      sourceDownload: "The resource is downloading, please wait",
      //emerg4director.js
      beginJjqb: "Start emergency backup video",
      stopJjqb: "Stop emergency backup video",
      // cg4director.js
      chooseAddImg: "Please select the image you want to add",
      nameNotNull: "Name cannot be empty",
      picAndZmMaxTy: "The number of pictures and subtitles cannot exceed 20",
      useSc: "Use successfully",
      cancelUse: "Cancel Use",
      plsChooseAddTemp: "Please select the template you want to add",
      isSureDelTemp: "Are you sure you want to delete this template",
      tempNameNotNull: "Template name cannot be empty",
      plsAddMode: "Please add a module",
      editSc: "Edit successful",
      // subtitle4director.js
      zangwen: "Tibetan",
      mengwen: "Mongolian",
      weiwen: "Uyghur",
      chaoxianwen: "Korean",
      plsChooseZmh: "Please select the subtitle box to add",
      xiugaiSc: "Modified successfully",
      isSureDelZmh: "Are you sure you want to delete this subtitle box",
      isSureDelZmt: "Are you sure you want to delete this subtitle strip",
      contentMust: "Content cannot be empty",
      addParkInTemp: "Please add a parking space in the template",
      noContentInTemp: "There is no content in the parking position in the template",
      noContentToAdd: "There is no content in this parking position and cannot be added",
      recordFile: "Recording Files",
      currenttime: "Current Time",
      availabletime: "Availabletime",
      follow: "Follow",
      cameraSwitch: "Camera Switch",
      templateSwitch: "Template Switch",
      transitionEffects: "Transition Effect",
      clicktoselectchannel: "Click to select channel",
      pgmCleanRecording: "PGMC lean Recording",
      cleanMsg1: "After it is turned on, clean recording of the streaming screen of the PGM",
      cleanMsg2: "The recording does not include the front image and subtitles on the screen",
      cleanMsg3: "If there is a background image, it will be recorded with the screen",
      viewRecordingList: "View Recording List",
      diskMsg1: "Current computer hard disk remaining",
      diskMsg2: "Current output bitrate",
      diskMsg3: "Estimated remaining recording time",
      controlMsg1: "has control",
      controlMsg2: "Acquiring control",
      controlMsg3: "Gain Control",
      controlMsg4: "Control switched",

      PGMfs: "PGM FOldback",
      zcfail: "Registration failed",
      ydblzwj: "Director Recording",
      delAfterSeven: "The recorded video will be automatically deleted after 7 days",
      gqTime: "expiry time",
      noLzwj: "No recording files",
      issureDelLzwj: "Are you sure you want to delete this recording",
      welcomeDbt: "Welcome to the Director",
      chooseDbType: "Select Director Type",
      ydbTip1: "云导播台按照运行分钟数扣费，采取先使用后付费的形式",
      ydbTip2: "若导播提前结束，则只按照使用的时长扣费",
      ydbTip3: "当余额不足时，导播间会赠送您5分钟，过时会自动关闭，请务必保证导播时长余量充足；创建后开始计费",
      nosearchCont: "No search content",
      lineLx: "Live Connection",
      bianji: "Edit",
      zwspsc: "No video available",
      addSpsc: "Add video",
      channel: "Channel",
      changeFail: "Switching failed",
      yebzzs5: "您的余额已不足，导播台免费赠送您5分钟，请及时充值",
      addPGMtoLive: "Please add PGM signal first before starting live broadcast",
      pzSc: "Configuration successful",
      peizhi: "configure",
      pailie: "array",
      captionBg: "Subtitle background",
      miaobian: "Stroke",
      mbcx: "Stroke thickness",
      yinying: "shadow",
      spPy: "Horizontal offset",
      czPy: "Vertical offset",
      mhcd: "Degree of ambiguity",
      duiqi: "alignment",
      linehight: "linehight",
      zijianju: "Word spacing",
      noLine: "Not connected",

      yinpin: "audio",
      importYp: "Import Audio",
      noYpFile: "There are currently no audio materials available",
      outputJw: "Output stand",
      cancelOutput: "Cancel Output",
      output: "output",
      ypChoose: "Audio selection",
      plsChooseImg: "Please select a picture",
      noDownload: "Audio download not completed, unable to input temporarily",
      noMusic: "No audio files available, unable to output",
      wbdjw: "Unable to output due to unbound slot",
      shuchuSc: "Output successful",
      isDelMusic: "Are you sure you want to delete this audio",
      musicTime: "Audio duration",
      plaseChooseFile: "Please select a file",
      musicPlaySet: "Audio playback settings",
      setRudian: "Set entry point",
      setOut: "Set exit point",
      rddycd: "The entry point cannot be greater than the exit point",
      crdjg: "The interval between entry and exit points cannot be less than 5 seconds",
      cddyrd: "The exit point must be greater than the entry point",
      jwSet: "The exit point must be greater than the entry point",
      chooseTlchannel: "Please select a streaming channel",
      ydChoose: "Cloud based selection",
      changeTh: "replace",
      tpjybl: "The recommended image scale",
      searchOnList: "Search in List Page",
    },
// CG管理
    cgManage:{
       beforeImg: "Foreground Image",
       bgImg: "Background Image",
       temp: "Template",
       subtitle: "Subtitle",
       subunit: "Component",
       // foreground 前景图
       cloudImport: "Cloud Material Import",
       uploadImg: "Upload Image",
       noForeground: "No foreground image yet~",
       scImportSc: "Material import successful",
       uoploadImgSc: "Upload image successfully",
       uploadImgFail: "Failed to upload file",
       uploadImgTypeErr: "The format of the uploaded image is incorrect, please upload it again",
       uploadImgSize: "Upload image size must not exceed 20M",
       imgDeled: "Image deleted",
       isSureDelImg: "Are you sure you want to delete this image",
       editImg: "Edit Image",
       plsChooseImg: "Please select an image",
       noContent: "No content yet",
      // background 背景图
      noBackground: "No background image yet~",
      // formwork 模板
      addMode: "Add Template",
      noSubtitle: "There is currently no director template~",
      modeDeled: "Template deleted",
      isSureDelMode: "Are you sure to delete the template",
      editMode: "Edit Template",
      newMode: "New Template",
      modeName: "Template Name",
      // subtitle 字幕
      newSubitleh: "New Subtitle Box",
      return: "Back",
      newSubitlet: "New subtitle strip",
      subitlehDeled: "SubitlehDeled",
      isSureDelSubitleh: "Are you sure you want to delete this subtitle box",
      subitletDeled: "SubitletDeled",
      isSureDelSubitlet: "Are you sure you want to delete this subtitle box",
      editSubitleh: "Edit Subtitle Box",
      newSubitleh: "New Subtitle Box",
      newSubtitle: "New Subtitle",
      nottitTemp: "No title template yet",
      titleNotNull: "Title name cannot be empty",
      creatImging: "Generating image, please wait",
      creatImgFail: "Failed to generate image",
      uploadImgFail: "Failed to upload image",
      // subunit component
      upload: "Upload",
      addWindow: "Add window",
      imageImport: "Image Import",
      cloud: "Cloud",
      local: "Local",
      cameraSelect: "Camera selection",
      positionNotRequired: "The camera position is not required, it can be added according to the actualuse after entering the director panel",
      donotAddSame: "Do not add the same camera",
      layer: "Layer",
      moreWarning: "NoteWhentherearemorethan4windows,itisrecommendednottooverlapthelayoutofmultiplewindowstopreventexcessiveperformanceconsumptionduringthedirectingprocess",
      noMore8: "The maximum number of Windows cannot exceed 8",

      moreRen: "Default",
      newText: "Create text",
      gouxuanTip1: "When checked, the first time you add a picture will appear in the PVW screen, and the picture will follow the PVW movement",
      nogouxuanTip2: "Unchecked, the picture will appear in both PVW and PGM screen",
      chuangkou: "Window",
      addHp: "Add horizontal screen",
      addSp: "Add vertical screen",
      yunddr: "Cloud Import",
      bddr: "Local Import",
      chooseImg: "Select picture",
      notChooseMore: "Cannot select the same screen",
      gouxuanZm: "When checked, the first time you add subtitles will appear in the PVW screen, and the subtitles will follow the PVW movement",
      notgouxuanZm: "Unchecked, subtitles will appear in both PVW and PGM screens",
    },
    // 素材管理 materiallist
    material:{
      materialMng: "Material Management",
      imgMng: "Image Management",
      addImg: "Add Image",
      size: "Size",
      uploadDate: "Upload Date",
      sckNoImg: "The picture material is empty, go and add it~",
      delImgSc: "Delete the picture successfully",
      isSureDelImg: "Are you sure you want to delete the picture",
      imgUploadSc: "Upload image successfully",
      fileUploadFail: "Failed to upload file",
      imgTypeErr: "The format of the uploaded image is incorrect, please re-upload",
    },
    // picture mosaic mosaicList
    mosaic:{
      roomName: "Room Name",
      pjType: "splicing type",
      rwStatus: "Task Status",
      syTime: "Time remaining",
      serviceOpen: "Service Open",
      look: "View",
      pinjie: "splicing",
      toCreateRw: "No task has been created yet, go and create a new one~",
      rwList: "Single task",
      jilian: "cascade",
      hechenging: "synthesizing",
      enabled: "Enabled",
      stopSynthesis: "Synthesis stopped",
      isSureDelRw: "Are you sure you want to delete this task",
      stopSc: "Successful deactivation",
      isSureStopRw: "Are you sure you want to stop this task",

      plsInpName: "Please enter a name",
      refresh: "Refresh",
      addTime: "Add Time",
      goOut: "Exit",
      noHcxh: "No synthetic signal yet",
      addTimes: "Add Time",
      chooseTimes: "Choose time duration",
      oneMini: "1 minute splicing service consumes 1G live stream",
      plsSureTime: "Please ensure sufficient time",
      pjtip1: "The splicing service adopts the form of payment after use. If it ends early, the fee will only be deducted according to the length of use,",
      pjtip2: "When the service time runs out, the system will give you 15 minutes, and it will be automatically closed when it is out of date. Please make sure that there is enough time left; the billing will start after creation.",
      goOutTip: "Exit Tip",
      closeNeedOpen: "The splicing service will be stopped after it is closed, and the remaining time will not be billed. It needs to be reopened if it is used again.",
      canUseTimeTt: "The available time is less than 30 minutes, please recharge the time",
      canUseTimeTen: "The available time is less than 10 minutes, please recharge the time",
      balanceAndRecharge: "Your balance is insufficient, you will be given 15 minutes for free, please recharge in time",
      serviceDisabled: "Service is disabled",
      renewalSc: "Renewal successful",
      notPay: "The service has stopped and cannot be recharged normally",
      // operateMosaicModal
      rwName: "Task Name",
      Splicing: "Splicing",
      synthesis: "synthesis",
      reFreshSc: "Refresh successful",
      minOneCy: "Select at least one member",
      minTwoCy: "Only two members can be selected to switch",
      hccybcg: "Composite members cannot exceed",
      ge: "one",
      hcSc: "Successful synthesis",
      //creatMosaicModal
      newRw: "New Task",
      openRw: "Open task",
      pjTemp: "Splice Template",
      chooseRoom: "Choose Room",
      chooseTime: "Duration",
      plsChooseTemp: "Please select a template",
      plsCHooseRoom: "Please select a room",
      // js
      enterRoomErr: "Failed to enter the room",
      sysErr: "System error",

      mobanManage: "Template Management",
      roomType: "Room Type",
      chooseMb: "Select Template",
      pjhmAddRoom: "Join the Room by Splicing Pictures",
      ydbTip11: "The fee for picture splicing shall be deducted according to the number of running minutes, and it shall be paid after use",
      ydbTip22: "If the guide ends ahead of schedule, the fee will be deducted only according to the duration of use",
      beginSc: "Open successfully",
      pjSet: "Splice settings",
      roomList: "Room member list",
      cyName: "Member nickname",
      chuangPosition: "window position",
      kong: "empty",
      sxList: "Refresh List",
      autoTcck: "Auto fill window",
      clearCk: "Empty all windows",
      pstNotCf: "The window position cannot be repeated, please select again",
      ckMax32: "Windows cannot exceed 32",
      plsAddCk: "Please add a window",
    }
  },
  // user user center
  user:{
      goOut: "Exit",
      gotoKzt: "Return to console",
      userCenter: "User Center",
      zhInfo: "Account Information",
      zzhMng: "Subaccount Management",
      userMng: "User Management",
      roleMng: "Role Management",
      loginZh: "Login account",
      userNc: "Username",
      none: "none",
      userId: "User ID",
      tenant: "Owning Account",
      tenantId: "Account ID",
      role: "role",
      userKey: "User KEY",
      slPh: "Phone",
      userEmil: "Email",
      changePhNumber: "Change phone number",
      authentication: "Authentication",
      changePh: "Change phone number",
      yzPass: "Verify Password",
      inputPass: "Please enter your password",
      newPhNumber: "New phone number",
      inputPhNumber: "Please enter the phone number",
      dxYz: "SMS Verification",
      plsInputYzm: "Please enter the verification code",
      getYzm: "Get verification code",
      reGet: "Re-get after",
      yanzheng: "Verify",
      inputLoginPass: "Please enter the login password",
      passErr: "Password incorrect",
      sendYzmSc: "Verification code sent successfully",
      editSc: "Modified successfully",
      inputYhNc: "Please enter user nickname",
      plsIptEmil: "Please enter your email address",
      editUserNc: "Edit User Nickname",
      editUserEmil: "Modify User Email",
      plsIptRightEmailAds: "Please enter a correct email address",
      zzhTree: "Subtenant tree",
      zzhInfo: "Subtenant Information",
      plsIptKeywordToSearch: "Please enter a keyword such as name or ID to search",
      qianfeiTip: "The current sub-tenant is in arrears. If you want to delete it, the amount in arrears will be deducted from your package",
      isSureDelZzh: "Are you sure you want to delete this subtenant",
      isJxcz: "After deleting the sub-tenant, the traffic still allocated under it will be returned to the parent tenant, whether to continue the operation",
      begin_endTime: "Start Date ~ End Date",
      topFatherTenant: "Top Parent Tenant",
      fped: "Allocation quota",
      user: "User",
      tenantName: "tenant name",
      plsIptTenantName: "Please enter the tenant name",
      childTenantId: "Sub-tenant ID",
      childTanantName: "Sub-tenant name",
      hasUsers: "Number of users",
      lastEditTime: "Last edit time",
      tip: "tip",
      contentNotSave: "The edited content is not saved, do you want to continue the operation",
      nopackage: "There is currently no package",
      tenantRemain: "Parent Tenant Remaining",
      childTenantOwne: "Subtenant Owned",
      distribution: "distribution",
      packageTYpechange: "The package consumption type has been modified to the top-level parent tenant mode",
      packageChoose: "Package Choice",
      add: "Add",
      reduce: "reduce",
      distributionMinOne: "The distribution cannot be less than 1",
      nogreaterThanRemain: "Allocation cannot be greater than parent tenant remaining",
      nogreaterThanOwne: "Allocation cannot be greater than subtenant owned",
      distributionSc: "Distribution successful",
      newRemain: "Current Remaining",
      nokown: "unknown",
      day: "day",
      tpqftc: "Fill in arrears package",
      IKown: "I know",
      arrearageContent: "Arrears Content",
      total: "Total",
      deductionPackage: "Deduction Package",
      nextStep: "Next step",
      lastStep: "Previous step",
      confirmRepayment: "Confirm Repayment",
      manage: "Management",
      packageType: "Package consumption type",
      packageContent: "package content",
      childTenantQf: "The current sub-tenant is in arrears, and the amount in arrears will be deducted from your package",
      childTenantHasLl: "The unconsumed traffic under the current sub-tenant will be returned to the parent tenant, whether to continue the operation",
      packageChangeAndshfp: "After the package consumption type is switched to 'Allocation quota', you need to manually allocate the package content, whether to continue the operation",
      batchAdd: "Batch Add",
      ssTenantName: "Tenant Name",
      file: "file",
      uploadFile: "Upload excel file",
      uploadSm: "Upload description",
      clickToDownloadTemp: "Click here to download the template",
      inputContent: "And fill in the form according to the content",
      uploadTempOnThere: "Upload the completed template here",
      fileMaxTt: "The file cannot exceed 20M",
      plsUploadFile: "Please upload file",
      importResult: "Import result",
      success: "Success",
      fail: "Failed",
      strip: "strip",
      errLine: "Error line number",
      errMsg: "Error message",
      newChildTenant: "New Child Tenant",
      plsIptName: "Please enter a name",
      nameNotNull: "Name cannot be empty",
      move: "move",
      qfTip2: "The current sub-tenant is in arrears. If you need to move, the amount in arrears will be deducted from your package",
      plsChooseATenant: "Please select a tenant",
      hasAndMove: "The selected tenant already exists, please select another tenant to move",
      sureMove: "Move Confirmation",
      isSureMoveCdTenant: "Are you sure you want to move this subtenant",
      moveAndFhgprt: "After moving the sub-tenant, the traffic still allocated under it will be returned to the parent tenant, whether to continue the operation",
      moveSc: "Move successfully",
      userList: "User List",
      userName: "Username",
      userRole: "User Role",
      noData: "No data currently",
      plsChoose: "Please choose",
      plsInputRoleName: "Please enter the role name to search",
      newRole: "New Role",
      fpqx: "Assign Permissions",
      roleName: "role name",
      createTime: "Creation Time",
      roleList: "role list",
      deled: "Deleted",
      jurisdiction: "authority",
      distributed: "Distributed",
      createRole: "Create Role",
      editRole: "Edit Role",
      name: "Name",
      createSc: "Created successfully",
      importRole: "Import Role",
      importSjzhList: "In order to facilitate your management, you can import the list of roles created by your superior tenant, as follows",
      reporter: "Reporter",
      importNow: "Import now",
      plsIptNmOrNc: "Please enter keywords such as username or nickname to search",
      changeRole: "Change Role",
      nickname: "Username",
      ssRole: "Owning Role",
      phoneNumber: "Phone Number",
      delFail: "Delete failed",
      isSureDelUser: "Are you sure you want to delete this user",
      plsChooseUser: "Please select a user",
      plsChooseOneTypeUser: "Please select a user under the same tenant",
      addUser: "Add User",
      zhanghao: "Account",
      plsIptRule: "Please enter the username, up to 50 characters, English or numbers are recommended",
      password: "Password",
      passRule: "At least 8 characters, must contain uppercase and lowercase letters, numbers, special characters",
      surePass: "Confirm Password",
      plsSurePass: "Ensure that the two entries are exactly the same",
      maxTtText: "Maximum 20 characters",
      phone: "Phone",
      inputPhNum: "Enter phone number",
      email: "Email",
      inputEmailAds: "Enter email addresses",
      plsIptUsername: "Please enter username",
      plsIptNickname: "Please enter a nickname",
      plsReIptPass: "Please enter your password again",
      plsChooseTenant: "Please select a tenant",
      getRolelistFail: "Failed to get role list",
      passRule1: "Password at least 8 characters, must contain uppercase and lowercase letters, numbers and special symbols",
      passRule2: "The two passwords are inconsistent, please re-enter",
      plsIptRightPh: "Please enter the correct phone number",
      batchImport: "Batch Import",
      chooseTenant: "Choose Tenant",
      uploadFail: "Upload file",
      fileSizeMaxTen: "The file cannot exceed 10M",
  },
  // sportlive 赛事直播
  sportlive:{
    // sportlive: "赛事直播",
    sportlive:"Live Matches",
    // sportliveList
    newChannel: "New Channel",
    schedule: "Schedule",
    programGuides: "Program Guide",
    monitor: "Monitor",
    noTvToNew: "There is no TV channel, go and create a new one~",
    isSureDelProgram: "Are you sure you want to delete this program",
    //sportliveEditModal
    editChannel: "Edit Channel",
    eventName: "Event Name",
    plsIptName: "Please enter a name within 20 characters",
    activityTime: "activity time",
    normalDate: "MM month dd day of yyyy year",
    plsChooseBeginEndTime: "Please select a start and end date",
    cover: "cover",
    uploadImg: "Upload Image",
    requirement: "Requirement",
    imgType: "The format is png, jpg, gif, etc.",
    delCover: "Delete Cover",
    plsIptBz: "Please enter the event remarks, within 50 characters",
    plsIptPdname: "Please enter a channel name",
    twoToTt: "2 to 20 characters",
    plsChooseCover: "Please select a cover",
    maxFt: "Cannot exceed 50 characters",
    uploadImgSc: "Upload image successfully",
    uploadFileFail: "Upload file failed",
    uploadSizeMax: "Upload images cannot exceed 3M",
    uploadImgErr: "The format of the uploaded image is incorrect, please re-upload",
    remarks: "Remarks",
    // schedule
    chooseDate: "Choose Date",
    downTemp: "Download import template",
    importSchedule: "Import Schedule",
    exportSchedule: "Export Schedule",
    list: "list",
    timeList: "timelist",
    addTime: "Add item",
    openScreen: "Open data screen",
    channel_time: "Channel/Time",
    HD: "High Definition",
    projectName: "Project Name",
    signalType: "Signal format",
    field: "Field",
    status: "Status",
    projectFl: "Project Category",
    open_close: "ON/OFF",
    address: "Address",
    noData: "No data currently",
    noinput: "No input yet",
    monday: "Monday",
    tuesday: "Tuesday",
    Wednesday: "Wednesday",
    Thursday: "Thursday",
    Friday: "Friday",
    Saturday: "Saturday",
    Sunday: "Sunday",
    noLiveStream: "No Live Stream",
    living: "Live",
    closed: "closed",
    ended: "Ended",
    notBegin: "Not started",
    noKown: "Unknown",
    publicEvents: "Public Events",
    minorityEvent: "Minority Event",
    openChannel: "Open the channel successfully",
    closeChannel: "Close the channel successfully",
    cancelEdit: "The operation was canceled",
    isSureOpenChannel: "Are you sure to open the channel?",
    isSureCloseChannel: "Are you sure to close the channel",
    editSure: "Operation Confirmation",
    fileSizemaxTt: "The file cannot exceed 30M",
    importSc: "Import successful",
    ssjmd: "Event Schedule",
    // conflictModal
    importErr: "Import Error",
    jmTimeConflict: "The import of the program list failed! The time of the following programs in your program list conflicts, please modify and retry the import",
    jmNeedEdit: "Failed to import program list! Please modify and retry import",
    wrongLocation: "Wrong Location",
    wrongInfo: "Wrong information",
    // scheduleEditModal
    newProgram: "New Program",
    editProgram: "Edit Program",
    plsIptProgramName: "Please enter the project name, within 50 characters",
    plsChooseTime: "Please choose a time",
    plsIptPID: "Please input PID, within 50 characters",
    signalFormat: "Signal Format",
    gqSRT: "High Definition SRT",
    xmType: "Item Category",
    plsIptType: "Please enter the item classification, within 50 characters",
    bscd: "Playground",
    plsIptBscd: "Please enter the competition venue, within 50 characters",
    dzInfo: "Battle Info",
    plsIptDdxx: "Please enter the match information, within 50 characters",
    xmBeizhu: "Item Notes",
    plsIptXmbz: "Please enter a project remark",
    plsXmname: "Please enter a project name",
    chooseBgt: "Please select a start time",
    chooseEdt: "Please select an end time",
    iptPID: "Please enter PID",
    plsIptXmfl: "Please enter item classification",
    iptBscd: "Please enter the playing field",
    iptDzxx: "Please enter match information",
    // streamAddressModal
    playAddress: "Play address",
    channelAddress: "Channel Address",
    pushAddress: "Push stream address",
    sourceCode: "source code",
    // monitorModal
    channelJk: "Channel monitoring",
    pushData: "Push data",
    liveData: "Live Recording",
    // LiveRecord
    today: "today",
    yesterday: "yesterday",
    beforeYesterday: "The day before yesterday",
    begin_endTime: "Start Time ~ End Time",
    searchTtData: "You can query the data of the last 60 days and the query time period is less than 30 days.",
    pushTimes: "Push duration",
    pushIp: "Push stream IP",
    pushFbl: "Push stream resolution",
    stopReason: "The reason for stopping streaming",
    maxTyDay: "The query time period cannot exceed 30 days",
    // StreamData
    maxSixHour: "The query time period cannot exceed 6 hours",
    // ChartPart
    VideoFps: "Video Frame Rate",
    VideoRate: "Video bit rate",
    AudioFps: "Audio Frame Rate",
    AudioRate: "Audio Bit Rate",
    nowNotPush: "The stream has not been pushed during this time period",
    Company: "Unit",
    // mix4program.js
    // scheduleBigscreen
    cloudChannelList: "Cloud Distribution Channel Orchestration List",
    // scheduleInfoModal
    jmxq: "Program Details",
    plsIptKeyword: "Please enter a keyword",
    exportJmd: "Export program list",
    noJmd: "No program list yet"
  },

  //连线成员管理列表
  connM:{
    stickTop:'Top',
    cancleTop:'Cancel topping',
    hide:'Hide',
    show:'Unhide',
    feedback:'Return box',
    cancelFeedback:'Cancel return',
    mute:'Mute',
    unmute:'Unmute',
    all:'All',
    nickname:'Alias',
    host:'anchor',
    hangUp:'Hang up',
    jieru:'Accessed',
    living:'Connecting',
    waitJoin:'Accessing',
    leaved:'Left',
    status:'Status',

    spfgx: "Vertical screen split line",
    fullScreen: "Full screen",
    volume: "Volume",
    tlFail: "Push stream failed",
    sxtwffw: "Camera inaccessible",
    mkfwffw: "Microphone not accessible",
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/i18n/langs/en.js